module.exports = __webpack_public_path__ + "static/media/HOMBRE-2.c258ac6b.svg";